// extracted by mini-css-extract-plugin
export var shake = "_2-0";